import React from 'react'
import PropTypes from 'prop-types'
import Page from '../../../containers/Debit/SuccessPage'

const Success = () => (
    <React.Fragment>
        <Page />
    </React.Fragment>
)

Success.propTypes = {
    children: PropTypes.node
}

export default Success